import React, { memo } from 'react';
import { View, Wrapper } from 'app/components/mediaModule/content/contentStyles';
import MediaComponentFactory from 'app/components/mediaModule/content/MediaComponentFactory';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
const MediaView = /*#__PURE__*/memo(function MediaView(_ref) {
  let {
    mediaList,
    pageIndex = 0
  } = _ref;
  const {
    trackClickedItemPage
  } = useDistrictMainPageTracking();
  const handleClick = () => {
    trackClickedItemPage(DistrictMainPageModuleType.MEDIA, pageIndex);
  };
  return /*#__PURE__*/React.createElement(View, {
    onClick: handleClick
  }, mediaList.map((mediaData, elementIndex) => {
    if (!mediaData) {
      return /*#__PURE__*/React.createElement(Wrapper, {
        key: "media-filler-".concat(elementIndex)
      });
    }
    return MediaComponentFactory.create(mediaData);
  }));
});
export default MediaView;